const ORDER_KEY = 'mukwei-preorders';

export const BOTTLE_PRICE = 320;
export const OUTSIDE_GAUTENG_SHIPPING = 90;
export const LAUNCH_DATE = new Date('2026-09-01T09:00:00+02:00');

const readOrders = () => {
  try {
    const value = window.localStorage.getItem(ORDER_KEY);
    return value ? JSON.parse(value) : [];
  } catch (error) {
    return [];
  }
};

const writeOrders = (orders) => {
  window.localStorage.setItem(ORDER_KEY, JSON.stringify(orders));
};

export const calculateTotal = (quantity, isOutsideGauteng) => {
  const subtotal = quantity * BOTTLE_PRICE;
  const shipping = isOutsideGauteng ? OUTSIDE_GAUTENG_SHIPPING : 0;

  return {
    subtotal,
    shipping,
    total: subtotal + shipping,
  };
};

export const formatCurrency = (amount) =>
  new Intl.NumberFormat('en-ZA', {
    style: 'currency',
    currency: 'ZAR',
    maximumFractionDigits: 0,
  }).format(amount);

const estimateDelivery = (isOutsideGauteng) => {
  const now = new Date();
  const baseDate = now > LAUNCH_DATE ? now : LAUNCH_DATE;
  const deliveryDate = new Date(baseDate);
  deliveryDate.setDate(deliveryDate.getDate() + (isOutsideGauteng ? 7 : 3));
  return deliveryDate.toISOString();
};

const inferStatus = (order) => {
  const today = new Date();
  const launchDate = new Date(LAUNCH_DATE);
  const eta = new Date(order.estimatedDelivery);

  if (today < launchDate) {
    return 'Awaiting launch day';
  }

  if (today >= eta) {
    return 'Delivered';
  }

  const twoDaysBeforeEta = new Date(eta);
  twoDaysBeforeEta.setDate(twoDaysBeforeEta.getDate() - 2);

  if (today >= twoDaysBeforeEta) {
    return 'In transit';
  }

  return 'Packed for dispatch';
};

export const createOrder = ({
  fullName,
  email,
  phone,
  quantity,
  isOutsideGauteng,
  address,
  orderId,
  paymentId,
  deliveryToken,
}) => {
  const totals = calculateTotal(quantity, isOutsideGauteng);
  const resolvedOrderId = orderId || `MUK-${Math.floor(100000 + Math.random() * 900000)}`;

  const order = {
    id: resolvedOrderId,
    fullName,
    email,
    phone,
    quantity,
    isOutsideGauteng,
    address,
    subtotal: totals.subtotal,
    shipping: totals.shipping,
    total: totals.total,
    createdAt: new Date().toISOString(),
    estimatedDelivery: estimateDelivery(isOutsideGauteng),
    status: 'Payment confirmed',
    paymentId: paymentId || null,
    deliveryToken: deliveryToken || null,
  };

  const orders = readOrders();
  orders.unshift(order);
  writeOrders(orders);

  return order;
};

export const findOrder = (orderId) => {
  if (!orderId) {
    return null;
  }

  const orders = readOrders();
  const order = orders.find((item) => item.id.toLowerCase() === orderId.toLowerCase());

  if (!order) {
    return null;
  }

  return {
    ...order,
    liveStatus: inferStatus(order),
  };
};
